// components
import { ControlledAutoComplete } from 'components/shared/ControlledFields';

// types
import { useFormContext } from 'react-hook-form';
import { QualificationResponse } from 'generated/index';
import { t } from 'i18next';
import { StyledMultiStepFormSection } from './QualificationSection.styles';

export const QualificationSection = ({
  qualificationOptions
}: {
  qualificationOptions: QualificationResponse[];
}) => {
  const { control } = useFormContext();

  return (
    <StyledMultiStepFormSection
      title={t('qualifications')}
      validateFields={['qualifications']}
    >
      <ControlledAutoComplete
        optionLabelProp="name"
        idProperty="id"
        variant="outlined"
        control={control}
        name="qualifications"
        label={t('qualifications')}
        options={qualificationOptions ?? []}
        multiple
        fullWidth
      />
    </StyledMultiStepFormSection>
  );
};
